import { Establishment } from '@/modules/accredited-establishments/api'
import { getEstablishmentDefaultImage } from '@/modules/accredited-establishments/functions'

const getValidEstablishmentImage = (establishment: Establishment): string => {
  const { icon, category } = establishment

  const isValidIcon =
    icon && icon.startsWith('https://s3.amazonaws.com/web.assets.alice.com.br/')

  return isValidIcon ? icon : getEstablishmentDefaultImage(category)
}

export { getValidEstablishmentImage }
